export const ga = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'UA-158051086-1');
`